
<template>
  <div style="display: flex;">
    <div class="box" style="margin-right:15px;flex:1">
      <div class="boxTitle">欧盟国家</div>
      <div class="echart">
        <div id="echart4" style="height:30vh;width: 100%;"></div>
      </div>
    </div>
  </div>

</template>

<script>
  import * as echarts from 'echarts';
	export default {
		name: "Four",
		data() {
      return {
        Chart:null,
        option:null
      }
		},
    mounted() {
      this.datainfo();
      this.datainfo2();
    },
    methods:{
      datainfo() {
        this.Chart = this.$echarts.init(document.getElementById('echart4'));
        this.option = {
  tooltip: {
    trigger: 'axis',
  },
  color: ['#0078ff', '#00ffcc'], //两条折线的颜色
  legend: {
    data: [
      {
        name: '进口',
        icon: 'circle', // 图例的图标样式

      },
      {
        name: '出口',
        icon: 'circle',
      },
    ],
    top: '10%',
    right: '10%',
    textStyle: { //图例的文字样式
      color: '#fff',
    },
  },

  xAxis: {
    type: 'category',
    boundaryGap: true,
    data: ['毛里求斯', '法国', '智利', '意大利', '中国', '肯尼亚', '阿联酋'],
    // 轴线的字体样式
    axisLabel: {
      show: true,
      textStyle: {
        color: '#fff',
        fontSize: '16',
        // fontSize: 16, 可直接写数字,单位px
      },
    },
    // 轴线的样式
    axisLine: {
      lineStyle: {
        color: '#273169',
      },
    },
    // 网格线样式
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#273169'],
      },
    },
    axisTick: {
      show: false, // 不显示坐标轴刻度
    },
  },
  yAxis: {
    type: 'value',
    name: '人民币', // y轴的单位,不写就没有
    nameTextStyle: { //单位'个'的样式
      color: '#fff',
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#fff',
        fontSize: '16',
      },
    },
    axisLine: {
      lineStyle: {
        color: '#273169',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#273169'],
      },
    },
  },
  series: [
    {
      name: '进口',
      type: 'line',
       data: [34, 44, 35, 38, 41, 37, 39],
      areaStyle: { // 要加这个属性,折线与下方的区域才能填充颜色
        // color: 'red', // 可以直接填充颜色
        color: { // 这边是设置渐变色,好看一点
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(0,156,255,0.5)',
            },
            {
              offset: 0.5, //这是于下方线的距离,设置1就不留空隙
              color: 'rgba(0,156,255,0)',
            },
          ],
          global: false,
        },
      },
    },
    {
      name: '出口',
      type: 'line',
      data: [18, 21, 15, 20, 10, 18, 12],
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(0,255,133,0.5)',
            },
            {
              offset: 0.9,
              color: 'rgba(0,255,133,0)',
            },
          ],
          global: false,
        },
      },
    },
  ],
};

        this.Chart.setOption(this.option);
      },

      datainfo2() {
        this.Chart2 = this.$echarts.init(document.getElementById('echart2'));
        this.option2 = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['意大利', '新西兰', '法国'],
               axisLine: {
                    lineStyle: {
                        color: '#fff' // 设置 x 轴颜色为红色
                    }
                },
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine:{
                show:false
              },
              axisLine: {
                  lineStyle: {
                      color: '#fff' // 设置 y 轴颜色为蓝色
                  }
              },
            }
          ],
          series: [
             {
              name: '进口',
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              data: [320, 332, 301],
              itemStyle: {
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#0076F5'},
                      {offset:0.5, color:'#00A1C2'},
                      {offset:1,color:'#00CF88'},
                    ]
                   )
                },
              },
            },
            {
              name: '出口',
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series'
              },
              data: [120, 132, 101],
              itemStyle: {
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#F6C40D'},
                      {offset:0.5, color:'#7B9D83'},
                      {offset:1,color:'#0376F6'},
                    ]
                   )
                },
              },
            },
          ]
        };

        this.Chart2.setOption(this.option2);
      }
    }
	}

</script>

<style>
  .echart{
    display:flex;
    justify-content:center;
  }
  .box{
    position:relative;
  }
  .miniTitle{
    font-size:15px;
    color:#fff;
    display:flex;
    width:100%;
    position:absolute;
    top:65px;
  }
  .miniTitle span{
    width:50%;
    padding-left:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/left/ten.vue